<template>
  <div class="py-6 text-center"></div>
</template>

<script setup lang="ts">
import { removePageFromUrl, removeParamsAndAnchors } from "../../utils/url"
const route = useRoute()

const routeToRedirect = removePageFromUrl(route.fullPath)

if (routeToRedirect !== route.fullPath) {
  await navigateTo(routeToRedirect, {
    redirectCode: 302
  })
}
</script>

<style scoped></style>
